import { ComputedRef, Ref } from 'vue'
import { Nullable } from 'frontcore/presentation/types'

export enum CalendarModeOptions { SELECT_DAY, SELECT_WEEK, SELECT_MONTH, SELECT_YEAR }

export type DayObject = {
  date: Date|null
  isCurrentDate: boolean
  isDisabled: boolean
  isSelected: boolean
  isInRange: boolean
  isStartDate: boolean
  isEndDate: boolean
  weekNumber: number
  isFirstDayOfWeek: boolean
  isLastDayOfWeek: boolean
  isWeekDisabled: boolean
}

export type MonthObject = {
  isDisabled: boolean
  index: number
  name: string
}

export type DateRange = readonly [Date?, Date?]

export type InputDateViewModel = {
  selectedDate: Nullable<Date> | DateRange
  startDate: Nullable<Date>
  endDate: Nullable<Date>
}

export type CoreCalendarViewModel = InputDateViewModel & {
  currentPickerMonth: number
  currentPickerYear: number
  daysInMonth: DayObject[]
  daysOfLastMonth: DayObject[]
  daysOfNextMonth: DayObject[]
  firstWeekNumber: number | null
  hasError: boolean
  isTodayDisabled: boolean
  mode: CalendarModeOptions
  monthsInYear: MonthObject[]
  offsetDays: number
  weekdayNames: string[]
}

export interface ICoreCalendarUseCase {
  viewmodel: CoreCalendarViewModel
  setCalendarSelectedDate: () => void
  updateInternalValue: (date: Nullable<Date> | DateRange) => void
  updateMode: (mode: number) => void
  updateMonth: (month: number) => void
  updateYear: (year: number) => void
}

export interface IInputDateUseCase {
  formattedDateValue: ComputedRef<string>
}

export type CalendarHeaderViewModel = {
  mode: CalendarModeOptions
  month: number
  monthName: string
  year: number
  yearList: number[]
}

export type DisabledDateFunction = (date: Date) => boolean

export type UseCoreCalendarArgs = {
  disabledDays?: Ref<Nullable<DisabledDateFunction|Date[]>>
  disableFutureDays?: Ref<boolean>
  disablePastDays?: Ref<boolean>
  nullable?: Ref<boolean>
  range?: Ref<boolean>
  selectionMode?: Ref<CalendarModeOptions>
  showWeekNumber?: Ref<boolean>
  value?: Ref<InputDateViewModel['selectedDate']>
}
